<template>
  <section class="block--base block--radius block--md block--column block--padding-1 block--margin--lr-auto block--with--background">
    <h1>Votre résultat</h1>
    <ring
      :radius="55"
      :stroke="5"
      :percent="percent"
    />
    <p v-if="percent >= 80 && user.sessions.length">Félicitation</P>

    <div >
      <template v-for="index in nbReponses">
        <div v-if="reponses[index] !== null && typeof reponses[index] === 'object'" :key="index" @click="toggle(reponses[index].id)">
          <div class="collapse collapse--header" :id="`${reponses[index].id}_header`" >
            <div class="cell">
              <font-awesome-icon :class="{ 'error': isFalse(reponses[index].id)}" icon="times-circle" v-if="isFalse(reponses[index].id)"/>
              <font-awesome-icon icon="check-circle" v-else />
            </div>
            <div class="cell">
              Dossier {{ reponses[index].id }}
            </div>
            <div class="cell">
             <span class="light">Voir la correction</span>
            </div>
            <div class="cell ">
             <font-awesome-icon icon="chevron-down" />
             <font-awesome-icon icon="chevron-up" />
            </div>
          </div>
          <embedVideo :code="reponses[index].code" v-if="reponses[index].code.length" class="collapse collapse--body" :id="`${reponses[index].id}_body`"/>
        </div>
      </template>
    </div>

    <router-link  class="btn " :to="{name: 'dashboard'}">Retour à l'accueil</router-link>

  </section>
</template>
<script>
import ring from '@/components/circle'
import embedVideo from '@/components/video'

export default {
  name: 'recap',
  components: {
    ring,
    embedVideo
  },
  data () {
    return {
      percent: 0,
      reponses: {},
      erreurs: []
    }
  },
  computed: {
    nbReponses () {
      if (this.user.sessions.length > 1) {
        return this.$store.state.alreadyAnswered
      }

      let keys = Object.keys(this.reponses)
      return keys.length
    }
  },
  methods: {
    toggle (id) {
      console.log(id)
      document.getElementById(`${id}_body`).classList.toggle('toggle')
      document.getElementById(`${id}_header`).classList.toggle('up')
    },
    isFalse (video) {
      let keys = Object.keys(this.erreurs)
      let result = false

      keys.forEach(i => {
        if (this.erreurs[i] === video) {
          result = true
        }
      })
      return result
    }
  },
  mounted () {
    this.HTTP.get(`/api/session/result`, { params: { current: this.$store.state.current, already: this.$store.state.alreadyAnswered } }).then(r => {
      let user = this.user
      this.percent = r.data.sessions.resultat
      this.reponses = r.data.solutions
      this.erreurs = r.data.erreurs
      user.sessions.push(r.data)
      this.$store.dispatch('setUser', user)
    })
  }
}
</script>
